module.exports = __webpack_public_path__ + "static/media/beegum.afc15c9b.jpg";